function fezoraInitAllCollectionsCarousels(root) {
  (root || document).querySelectorAll('[data-fezora-collections-carousel]').forEach(function (section) {
    if (section.dataset.fezoraInitialized) return;
    section.dataset.fezoraInitialized = 'true';
    initFezoraCollectionsCarousel(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    fezoraInitAllCollectionsCarousels(document);
  });
} else {
  fezoraInitAllCollectionsCarousels(document);
}

// Re-init when Shopify's theme editor adds/reloads this section (customizer preview)
document.addEventListener('shopify:section:load', function (event) {
  fezoraInitAllCollectionsCarousels(event.target);
});

function initFezoraCollectionsCarousel(section) {
  var track = section.querySelector('[data-fezora-collections-track]');
  var prevBtn = section.querySelector('[data-fezora-collections-prev]');
  var nextBtn = section.querySelector('[data-fezora-collections-next]');
  if (!track || !prevBtn || !nextBtn) return;

  function scrollStep() {
    return track.clientWidth;
  }

  function updateArrows() {
    var maxScroll = track.scrollWidth - track.clientWidth - 1;
    prevBtn.disabled = track.scrollLeft <= 0;
    nextBtn.disabled = track.scrollLeft >= maxScroll;
  }

  prevBtn.addEventListener('click', function () {
    track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', function () {
    track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows);
  updateArrows();
}
